// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"22095c49","453":"d855a71b","905":"2f007d62"}[chunkId] + ".chunk.js";
};